interface useCyclicVisibilityProps {
  visibleDuration?: number;
  intervalDuration: number;
}
export const useCyclicVisibility = (props?: useCyclicVisibilityProps) => {
  const { visibleDuration = 2000, intervalDuration = 5000 } = props || {};
  const timerRef = useRef<{
    showTimer?: number;
    intervalTimer?: number;
  }>({});

  const [show, setShow] = useState(false);

  const clearTimers = useCallback(() => {
    const timers = timerRef.current;
    if (timers.showTimer) {
      clearTimeout(timers.showTimer);
    }
    if (timers.intervalTimer) {
      clearInterval(timers.intervalTimer);
    }
    timerRef.current = {};
  }, []);

  const showAndHide = useCallback(() => {
    setShow(true);
    timerRef.current.showTimer = setTimeout(() => {
      setShow(false);
    }, visibleDuration);
  }, [visibleDuration]);

  const checkShow = useCallback(
    (check: boolean) => {
      clearTimers();
      if (check) {
        setShow(false);
        return;
      }
      showAndHide();
      timerRef.current.intervalTimer = setInterval(
        showAndHide,
        visibleDuration + intervalDuration
      );
    },
    [clearTimers, showAndHide, visibleDuration, intervalDuration]
  );

  useEffect(() => {
    return () => clearTimers();
  }, [clearTimers]);

  return { show, checkShow };
};
